import {
    CONTINUE_CREDIT_APP,
    GO_BACK_CREDIT_APP,
    RESET_CREDIT_APP,
    SET_COSIGNER_QUESTION,
    SET_CREDIT_APPLICATION_ID,
    SKIP_CREDIT_APP,
} from "../../constants/creditApp";
import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { FormData } from "Shared/Form";

export interface ContinueCreditAppAction {
    type: CONTINUE_CREDIT_APP;
}

export function continueCreditAppAction(): ContinueCreditAppAction {
    return {
        type: CONTINUE_CREDIT_APP,
    };
}

export interface GoBackCreditAppAction {
    type: GO_BACK_CREDIT_APP;
}

export function goBackCreditAppAction(): GoBackCreditAppAction {
    return {
        type: GO_BACK_CREDIT_APP,
    };
}

export interface ResetCreditAppAction {
    type: RESET_CREDIT_APP;
}

export function resetCreditAppAction(): ResetCreditAppAction {
    return {
        type: RESET_CREDIT_APP,
    };
}

export interface SkipCreditApplication {
    type: SKIP_CREDIT_APP;
}

export function skipCreditAppAction(): SkipCreditApplication {
    return {
        type: SKIP_CREDIT_APP,
    };
}
export interface SetCosignerQuestion {
    type: SET_COSIGNER_QUESTION;
    data: { hasCosigner: boolean };
}

export function setCosignerQuestion(data: FormData): SetCosignerQuestion {
    return <SetCosignerQuestion>{
        data,
        type: SET_COSIGNER_QUESTION,
    };
}

export interface SetCreditApplicationId {
    type: SET_CREDIT_APPLICATION_ID;
    data: { application_id: string; vin: string };
}

export function setCreditApplicationId(data: { application_id: string; vin: string }): SetCreditApplicationId {
    return {
        data,
        type: SET_CREDIT_APPLICATION_ID,
    };
}

export const setCreditApplicationPageToDecision = actionCreator("credit_app/set/decision");
